<template>
  <div v-if="puppy">
    <!-- <div
      class="relative mx-4  h-fit w-fit my-auto overflow-hidden rounded-xl bg-blue-gray-500 bg-clip-border text-white shadow-lg shadow-blue-gray-500/40 bg-gradient-to-r from-orange-500 to-orange-600">
      <img class="object-contain  h-96 w-96" :src="puppy.src" alt="Sunset in the mountains">
      
    </div> -->
    <div class="mx-auto mt-6 max-w-2xl sm:px-6 lg:grid lg:max-w-7xl lg:grid-cols-3 lg:gap-x-8 lg:px-8">
      <div class="aspect-h-4 aspect-w-3 hidden overflow-hidden rounded-lg lg:block">
        <img :src="puppy.src" :alt="puppy.name" class="h-full w-full object-cover object-center" />
      </div>
      <div class="flex mx-auto h-11/12 w-11/12 aspect-h-4 aspect-w-3 overflow-hidden rounded-lg lg:hidden">
                <img :src="puppy.src" :alt="puppy.name" class="h-full w-full object-cover object-center" />
            </div>
      <div class="hidden lg:grid lg:grid-cols-1 lg:gap-y-8">
        <div class="aspect-h-2 aspect-w-3 overflow-hidden rounded-lg">
          <img :src="puppy.src" :alt="puppy.name" class="h-full w-full object-cover object-center" />
        </div>
        <div class="aspect-h-2 aspect-w-3 overflow-hidden rounded-lg">
          <img :src="puppy.src" :alt="puppy.name" class="h-full w-full object-cover object-center" />
        </div>
      </div>
      <div class="aspect-h-5 aspect-w-4 lg:aspect-h-4 lg:aspect-w-3 sm:overflow-hidden sm:rounded-lg">
        <!-- <img :src="puppy.src" :alt="puppy.name" class="h-full w-full object-cover object-center" /> -->
        <div
          class="mx-auto max-w-2xl px-4 pb-16 pt-10 sm:px-6 lg:grid lg:max-w-7xl lg:grid-cols-3 lg:grid-rows-[auto,auto,1fr] lg:gap-x-8 lg:px-8 lg:pb-24 lg:pt-16">

          <div class="lg:col-span-2 lg:border-r lg:border-gray-200 lg:pr-8">
            <h1 class="text-2xl font-bold tracking-tight text-gray-900 sm:text-3xl">{{ puppy.name }}</h1>
          </div>

          <!-- Description -->
          <div class="mt-4 lg:col-span-3 lg:mt-4">
            <h3 class="sr-only">Description</h3>
            <div class="space-x-6 my-4">
              <p class="text-base font-bold text-gray-900">{{ puppy.breed }}</p>
            </div>
            <div class="space-x-6">
              <p class="text-base text-gray-900">{{ puppy.description }}</p>
            </div>
          </div>

          <router-link to="/contact"
            class="mt-10 flex w-full items-center justify-center rounded-md border border-transparent bg-orange-600 px-8 py-3 text-base font-medium text-white hover:bg-orange-500 hover:shadow-md hover:-translate-y-1 duration-100 focus:outline-none focus:ring-2 focus:ring-orange-500 focus:ring-offset-2">ADOPT</router-link>
          <router-link to="/adopt"
            class="mt-10 flex w-full items-center justify-center rounded-md border border-solid border-orange-600 px-8 py-3 text-base font-medium text-orange-500 hover:bg-orange-600 hover:text-white focus:outline-none focus:ring-2 focus:ring-orange-500 focus:ring-offset-2">BACK</router-link>
        </div>
      </div>
    </div>
  </div>
  <div v-else>
    <NotFoundView />
  </div>
</template>

<script>
import PuppyData from '@/assets/json/PuppyData.json';
import NotFoundView from '@/views/NotFoundView.vue'

export default {
  name: 'puppyDetailPage',
  data() {
    return {
      // puppy: PuppyData.find(puppy => puppy.id === 2)
      puppy: PuppyData[this.$route.params.pid - 1]

    }
  },
  components: {
    NotFoundView
  },
}
</script>